import React, { useEffect, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import purifyHTML from "../../../utils/purify-html";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, TextField, Typography } from "@mui/material";

import { addWidget, addContent } from "../../../redux/actions/Content";
import { FileDropzone } from "../../../components/addcontent/FileDropzone";
import { formatWebsiteUrl } from "./DialogBoxWebSite";
import { api } from "src/api/endpoints";

export default function DialogBoxPostermywall({ isOpen, onClose, onAddWidget, onAddContent, isIcon, startupData }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentFolder } = useSelector((state) => state.FileFolder);
  const { user } = useSelector((state) => state.User);

  //Form fields
  const [name, setName] = useState("");
  const [embedCode, setEmbedCode] = useState("");
  const [file, setFile] = useState(null);
  const [addStep, setAddStep] = useState(0)
  const [altVideoURL, setAltVideoURL] = useState("")

  useEffect(() => {
    handleDialogClose();
    if(startupData){
      setName(startupData?.name);
      setEmbedCode(startupData?.widget?.url);
    }
  }, [isOpen]);

  const handleFileDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
  }, []);

  const handleRemoveFile = useCallback(() => {
    setFile(null);
  }, []);

  const handleDialogClose = useCallback(() => {
    setName("");
    setEmbedCode("");
    setFile(null);
    setAddStep(0)
    setAltVideoURL('')
  }, []);

  const handleAdd = useCallback(async () => {
    const isEmbed = !!embedCode;

    if (name === "" || (!file && !embedCode) || !embedCode.includes('postermywall.com')) {
      toast.error(t("views.dialogBoxPostermywall.fillRequiredFields"));
      return;
    }

    let action;

    if (isEmbed) {
      let embedHTML = purifyHTML.sanitize(embedCode, { ADD_TAGS: ["iframe"] });
      embedHTML = embedCode.replaceAll(/"/g, '\\"').replaceAll(/\n/g, '\\n').toString();
      action = onAddWidget({ name, type: 'widget', widgetCat: 'postermywall', widgetIcon: isIcon, intervalValue: '', url: formatWebsiteUrl(embedCode), folderId: currentFolder, user: user._id });
    } else {
      //Handle file
      // const form = new FormData();
      // form.append("content", file);
      // form.append("user", user.isMember ? user?.user._id : user._id);
      // form.append("subuser", user.isMember ? user?.user._id : user._id);
      // form.append("role", user.isMember ? user?.role.split('-')[0] : user?.role);
      // form.append("folderId", currentFolder);

      action = onAddContent({
        preventDefault: () => {},
        target: {
          files: [file]
        }
      });
    }

    const result = await action;
    handleDialogClose()
    // console.log(result)
    // if (result?.id) {
    //     setName(result?.name)
    //     setAddStep(1)

    //     try {
    //         const { data, status } = await api.post('/content/pm2video', {
    //             url: formatWebsiteUrl(embedCode),
    //             contentId: result?.id
    //         })
    //         setAltVideoURL(data?.uri)
    //         setAddStep(2)
    //     } catch (err) {
    //         setAltVideoURL('ERROR')
    //         setAddStep(2)
    //     }        
    // }else {
    //     handleDialogClose()
    // }

    // (async () => {
    //   await action;
    //   onClose();
    //   return;
    // })();

  }, [name, embedCode, file]);

  return (
    <>
      <Dialog fullWidth open={isOpen} onClose={() => onClose(false)}>
        <Box display="flex" alignItems="center" justifyContent="center" mt={2}>
          <img src={"./images/postermywallLogo.png"} alt="Logo" width={"150px"} />
        </Box>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>{addStep == 0 ? t("views.dialogBoxPostermywall.title") : name}</DialogTitle>
        <DialogContent sx={{ minHeight: "30vh" }}>
          <Grid container spacing={2}>
            {addStep == 0 ? (
                <>
                    <Grid item xs={12} mt={2}>
                    <Button href="https://www.postermywall.com/index.php?rid=1031" target="_blank" variant="contained" color="primary" underline="none">
                        {t("views.dialogBoxPostermywall.loginToPostermywall")}
                    </Button>
                    </Grid>
                    <Grid item xs={12} mt={2}>
                    <TextField label={t("views.dialogBoxPostermywall.designName")} fullWidth value={name} onChange={(e) => setName(e.target.value)} disabled={startupData ? true : false} />
                    </Grid>
                    <Grid item xs={12} mt={3}>
                    <Typography variant="h6">{t("views.dialogBoxPostermywall.addAsWebsiteLink")}</Typography>
                    <Box display="flex" alignItems="center" mt={3}>
                        <TextField
                        variant="outlined"
                        label={t("views.dialogBoxPostermywall.websiteLink")}
                        fullWidth
                        value={embedCode}
                        rows={1}
                        onChange={(e) => setEmbedCode(e.target.value)}
                        disabled={!!file}
                        />
                    </Box>
                    <Typography align="right" mt={2}>
                        <Link href="https://youtu.be/9tQxqqvEw8Q" target="_blank">
                        {t("views.dialogBoxPostermywall.howToGetWebsiteLink")}
                        </Link>
                    </Typography>
                    </Grid>                
                </>                
            ) : (
                <>
                    {(addStep == 1 || addStep == 2) && (
                        <>
                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "200px",
                                flexDirection: "column",
                                mt: 3
                            }}>
                                {addStep == 1 && (
                                    <CircularProgress/>
                                )}
                                {(addStep == 2 && altVideoURL == 'ERROR') && (
                                    <>
                                        <Typography variant='subtitle1' textAlign={"center"} color={"warning.main"}>An error occured</Typography>
                                        <Typography variant='subtitle2' textAlign={"center"} color={"warning.main"} sx={{
                                            mt:2
                                        }}>Failed to create alternative video</Typography>
                                    </>
                                )}
                                {(addStep == 2 && altVideoURL !== 'ERROR') && (
                                    <>
                                        <video autoPlay width={400} height={350} muted controls>
                                            <source src={altVideoURL} type="video/mp4" />
                                        </video>
                                    </>
                                )}
                            </Box>
                        </>
                    )}                
                </>
            )}
            {
              !startupData ? (
                <Grid item xs={12}>
                  {/* <Typography variant="h6">{t("views.dialogBoxPostermywall.orUploadFile")}</Typography>
                  <Box mt={4} display="flex">
                    <FileDropzone
                      accept={{
                        "image/jpeg": [],
                        "image/png": [],
                        "image/webp": [],
                        "image/heic": [],
                        "image/jfif": [],
                      }}
                      caption={t("views.dialogBoxPostermywall.maxFileSize")}
                      files={[file].filter(Boolean)}
                      disabled={!!embedCode}
                      onDrop={handleFileDrop}
                      onRemove={handleRemoveFile}
                      onRemoveAll={handleRemoveFile}
                      onUpload={() => { }}
                      multiple={false}
                      maxFiles={1}
                    />
                  </Box> */}
                </Grid>
              ) : null
            }
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 2,
            marginTop: 1,
          }}>
          <div style={{ marginLeft: "auto" }}>
            <Button onClick={() => onClose(false)}>{addStep == 0 ? t("views.dialogBoxPostermywall.cancel") : "Close"}</Button>
            {addStep == 0 && (
                <Button variant="contained" color="primary" onClick={handleAdd}>
                {t("views.dialogBoxPostermywall.save")}
                </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
